import { DefaultTheme } from "@deliverr/ui";
import { LoadingSpinner } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React from "react";
import { ShipToStoreLabelTable } from "./components";
import { useShipToStoreLabel } from "./useShipToStoreLabel";

const Container = styled.div<{}, DefaultTheme>(({ theme }) => `margin: ${theme.spacing.S5};`);

const Card = styled.div<{}, DefaultTheme>(
  ({ theme }) => `
  padding: ${theme.spacing.S5};
  background: ${theme.colors.NEUTRAL["00"]};
  border-radius: ${theme.border.radius.R5};
  box-shadow: ${theme.shadow.S2};
  margin-bottom: ${theme.spacing.S5};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.S4};
`
);

const StyledContainer = styled(Container)`
  margin-bottom: 30px;
`;

export const ShipToStoreLabel = () => {
  const {
    shipToStoreLabels,
    isPrinting,
    hasConnectedPrinter,
    printSummary,
    isLoading,
    printLabels,
    cancelLabels,
    onRefetch,
  } = useShipToStoreLabel();

  return (
    <StyledContainer>
      <Card>
        <LoadingSpinner loading={isLoading} text="Loading Labels">
          <ShipToStoreLabelTable
            shipToStoreLabels={shipToStoreLabels}
            printLabels={printLabels}
            cancelLabels={cancelLabels}
            isPrinting={isPrinting}
            hasConnectedPrinter={hasConnectedPrinter}
            printSummary={printSummary}
            onRefetch={onRefetch}
          />
        </LoadingSpinner>
      </Card>
    </StyledContainer>
  );
};
